/**
 * The focus outline is a global style that is used to
 * indicate that an element is focused. It does this by adding a
 * border around the element.
 *
 * The focus outline is only applied to elements that are focused
 * using the `:focus-visible` pseudo-class.
 */
const GlobalStyles = (theme) => {
    var _a;
    return `
    .CareFocusOutline {
      position: relative;
    }

    .CareFocusOutline {
      position: relative;
    }

    .CareFocusOutline::before {
      content: '';
      position: absolute;
      top: -1px;
      left: -1px;
      right: -1px;
      bottom: -1px;
      border: 2px solid;
      border-radius: 6px;
      border-color: ${theme.themeName === 'embrace' ? (_a = theme.palette.border) === null || _a === void 0 ? void 0 : _a.interactive.focus : theme.palette.state.focused};
      z-index: 1;
      display: none;
    }

    .CareFocusOutline:focus-visible::before {
      display: block;
    }
  `;
};
export default GlobalStyles;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2xvYmFsU3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbmZpZy9jb21wb25lbnRzL0dsb2JhbFN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTs7Ozs7OztHQU9HO0FBQ0gsTUFBTSxZQUFZLEdBQUcsQ0FBQyxLQUFZLEVBQUUsRUFBRTs7SUFDcEMsT0FBTzs7Ozs7Ozs7Ozs7Ozs7Ozs7O3NCQWtCYSxLQUFLLENBQUMsU0FBUyxLQUFLLFNBQVMsQ0FBQyxDQUFDLENBQUMsTUFBQSxLQUFLLENBQUMsT0FBTyxDQUFDLE1BQU0sMENBQUUsV0FBVyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsT0FBTzs7Ozs7Ozs7R0FReEgsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGVBQWUsWUFBWSxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgVGhlbWUgfSBmcm9tICdAbXVpL21hdGVyaWFsJztcblxuLyoqXG4gKiBUaGUgZm9jdXMgb3V0bGluZSBpcyBhIGdsb2JhbCBzdHlsZSB0aGF0IGlzIHVzZWQgdG9cbiAqIGluZGljYXRlIHRoYXQgYW4gZWxlbWVudCBpcyBmb2N1c2VkLiBJdCBkb2VzIHRoaXMgYnkgYWRkaW5nIGFcbiAqIGJvcmRlciBhcm91bmQgdGhlIGVsZW1lbnQuXG4gKlxuICogVGhlIGZvY3VzIG91dGxpbmUgaXMgb25seSBhcHBsaWVkIHRvIGVsZW1lbnRzIHRoYXQgYXJlIGZvY3VzZWRcbiAqIHVzaW5nIHRoZSBgOmZvY3VzLXZpc2libGVgIHBzZXVkby1jbGFzcy5cbiAqL1xuY29uc3QgR2xvYmFsU3R5bGVzID0gKHRoZW1lOiBUaGVtZSkgPT4ge1xuICByZXR1cm4gYFxuICAgIC5DYXJlRm9jdXNPdXRsaW5lIHtcbiAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICB9XG5cbiAgICAuQ2FyZUZvY3VzT3V0bGluZSB7XG4gICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgfVxuXG4gICAgLkNhcmVGb2N1c091dGxpbmU6OmJlZm9yZSB7XG4gICAgICBjb250ZW50OiAnJztcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHRvcDogLTFweDtcbiAgICAgIGxlZnQ6IC0xcHg7XG4gICAgICByaWdodDogLTFweDtcbiAgICAgIGJvdHRvbTogLTFweDtcbiAgICAgIGJvcmRlcjogMnB4IHNvbGlkO1xuICAgICAgYm9yZGVyLXJhZGl1czogNnB4O1xuICAgICAgYm9yZGVyLWNvbG9yOiAke3RoZW1lLnRoZW1lTmFtZSA9PT0gJ2VtYnJhY2UnID8gdGhlbWUucGFsZXR0ZS5ib3JkZXI/LmludGVyYWN0aXZlLmZvY3VzIDogdGhlbWUucGFsZXR0ZS5zdGF0ZS5mb2N1c2VkfTtcbiAgICAgIHotaW5kZXg6IDE7XG4gICAgICBkaXNwbGF5OiBub25lO1xuICAgIH1cblxuICAgIC5DYXJlRm9jdXNPdXRsaW5lOmZvY3VzLXZpc2libGU6OmJlZm9yZSB7XG4gICAgICBkaXNwbGF5OiBibG9jaztcbiAgICB9XG4gIGA7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBHbG9iYWxTdHlsZXM7XG4iXX0=